<template>
  <div>
    <b-container>
      <div class="mt-4 d-flex align-items-start justify-content-between">
        <back-arrow :title="addressTitle"/>
        <div class="d-flex align-items-center">
          <show-actions
            @clickOnEditBtn="clickOnEditBtn"
            @clickOnDeleteBtn="clickOnDeleteBtn"
            @clickOnNewIntervention="goToNewIntervention"
            :showNewRDV="true"
          ></show-actions>

        </div>
      </div>
      <b-card class="mt-2 mb-4 shadow-sm">
        <div class="row">
          <div class="col-12 col-md-6 col-lg-4  mb-2">
            <div class="bold-text">
              {{ $t('addressIntervention.postalCode') }}
            </div>
            <div>
              {{ addressIntervention.postalCode}}
            </div>
          </div>

          <div class="col-12 col-md-6 col-lg-4  mb-2">
            <div class="bold-text">
              {{ $t('addressIntervention.city') }}
            </div>
            <div>
              {{ addressIntervention.city }}
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-md-6 col-lg-4  mb-2">
            <div class="bold-text">
              {{ $t('addressIntervention.address') }}
            </div>
            <div>
              {{ addressIntervention.address }}
            </div>
          </div>

          <div class="col-12 col-md-6 col-lg-4  mb-2">
            <div class="bold-text">
              {{ $t('addressIntervention.AdditionalAddress') }}
            </div>
            <div>
              {{ addressIntervention.additionalAddress }}
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-md-6 col-lg-4  mb-2" v-if="addressIntervention.tenant != null">
            <div class="bold-text">
              {{ $t('Tenant') }} :
            </div>
            <div>
              <a class="force-link" href="javascript:void(0)" @click="goToClient('tenant')">{{ addressIntervention.tenant.name }}</a>
            </div>
          </div>
          <div class="col-12 col-md-6 col-lg-4 mb-2" v-if="addressIntervention.owner != null">
            <div class="bold-text">
              {{ $t('Owner') }} :
            </div>
            <div>
              <a class="force-link" href="javascript:void(0)"  @click="goToClient('owner')">{{ addressIntervention.owner.name }}</a>
            </div>
          </div>
          <div class="col-12 col-md-6 col-lg-4 mb-2" v-if="addressIntervention.agency != null">
            <div class="bold-text">
              {{ $t('Agency') }} :
            </div>
            <div>
              <a class="force-link" href="javascript:void(0)"  @click="goToClient('agency')">{{ addressIntervention.agency.name }}</a>
            </div>
          </div>
        </div>
      </b-card>

      <div class="bold-text main-color mb-4" style="font-size: 150%;">
        {{ $t("Historic") }}
      </div>
      <b-card class="mt-2 mb-4 p-3 shadow-sm">
        <div class="row">

          <b122-table
            style="width: 100%;"
            :ref="'B122TableIntervention-'+addressInterventionId"
            :identifier="'B122TableIntervention-'+addressInterventionId"
            :init-b122-table-url="'/intervention/initB122Table?restrictbylong-historicByAddressIntervention='+addressInterventionId"
            :get-b122-table-results-url="'/intervention/getB122TableResults?restrictbylong-historicByAddressIntervention='+addressInterventionId"
            :fields="tableFields"
            color-date-picker="pink"
            @setTotalCount="setTotalCount"
            @clickOnShowBtn="clickOnShowInterventionBtn"
            @clickOnEditBtn="clickOnEditInterventionBtn"
            @clickOnDeleteBtn="clickOnDeleteInterventionBtn"
          >
          </b122-table>

        </div>
      </b-card>


      <div class="bold-text main-color mb-4" style="font-size: 150%;">
        {{ $t("Installation") }}
      </div>
      <b-card class="mt-2 mb-4 shadow-sm">
        <div class="row">
          <div class="col-12 col-md-6 col-lg-4 mb-2" v-if="devices.length > 0">
            <div class="bold-text">
              {{ $t('client.Device') }}
            </div>
            <div v-for="device in devices">
              <a @click=goToDevice(device) href="javascript:void(0)">{{ device.name }} ({{device.year}})</a>
            </div>
          </div>

          <div class="col-12 col-md-6 col-lg-4 mb-2" v-if="addressIntervention.typeDevice !== null">
            <div class="bold-text">
              {{ $t('addressIntervention.TypeDevice') }}
            </div>
            <div>
              {{ addressIntervention.typeDevice }}
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-md-6 col-lg-4 mb-2" v-if="addressIntervention.outdoorSensor != null">
            <div class="bold-text">
              {{ $t('addressIntervention.OutdoorSensor') }}
            </div>
            <div>
              {{ addressIntervention.outdoorSensor ? "Oui" : "Non"  }}
            </div>
          </div>
          <div class="col-12 col-md-6 col-lg-4 mb-2" v-if="addressIntervention.heatedFloor != null">
            <div class="bold-text">
              {{ $t('addressIntervention.HeatedFloor') }}
            </div>
            <div>
              {{ addressIntervention.heatedFloor ? "Oui" : "Non" }}
            </div>
          </div>
          <div class="col-12 col-md-6 col-lg-4 mb-2" v-if="addressIntervention.lowVentilation != null">
            <div class="bold-text">
              {{ $t('addressIntervention.LowVentilation') }}
            </div>
            <div>
              {{ addressIntervention.lowVentilation ? "Oui" : "Non" }}
            </div>
          </div>
          <div class="col-12 col-md-6 col-lg-4 mb-2" v-if="addressIntervention.roomThermostat != null && addressIntervention.roomThermostatType != null">
            <div class="bold-text">
              {{ $t('addressIntervention.RoomThermostat') }}
            </div>
            <div>
              {{ addressIntervention.roomThermostat ? addressIntervention.roomThermostatType : "Non" }}
            </div>
          </div>
          <div class="col-12 col-md-6 col-lg-4 mb-2" v-if="addressIntervention.roaiTap != null">
            <div class="bold-text">
              {{ $t('addressIntervention.RoaiTap') }}
            </div>
            <div>
              {{ addressIntervention.roaiTap ? "Oui" : "Non" }}
            </div>
          </div>
          <div class="col-12 col-md-6 col-lg-4 mb-2" v-if="addressIntervention.gasHose != null">
            <div class="bold-text">
              {{ $t('addressIntervention.GasHose') }}
            </div>
            <div>
              {{ addressIntervention.gasHose ? "Oui" : "Non" }}
            </div>
          </div>
          <div class="col-12 col-md-6 col-lg-4 mb-2" v-if="addressIntervention.extractorHood != null">
            <div class="bold-text">
              {{ $t('addressIntervention.ExtractorHood') }}
            </div>
            <div>
              {{ addressIntervention.extractorHood ? "Oui" : "Non" }}
            </div>
          </div>
          <div class="col-12 col-md-6 col-lg-4 mb-2" v-if="addressIntervention.fluePipe != null">
            <div class="bold-text">
              {{ $t('addressIntervention.FluePipe') }}
            </div>
            <div>
              {{ addressIntervention.fluePipe }}
            </div>
          </div>
          <div class="col-12 col-md-6 col-lg-4 mb-2" v-if="addressIntervention.condensateEvacuation != null">
            <div class="bold-text">
              {{ $t('addressIntervention.CondensateEvacuation') }}
            </div>
            <div>
              {{ addressIntervention.condensateEvacuation ? "Oui" : "Non" }}
            </div>
          </div>
          <div class="col-12 col-md-6 col-lg-4 mb-2" v-if="addressIntervention.pipesBehindBoiler != null">
            <div class="bold-text">
              {{ $t('addressIntervention.PipesBehindBoiler') }}
            </div>
            <div>
              {{ addressIntervention.pipesBehindBoiler ? "Oui" : "Non" }}
            </div>
          </div>
          <div class="col-12 col-md-6 col-lg-4 mb-2" v-if="addressIntervention.areaHouse != null">
            <div class="bold-text">
              {{ $t('addressIntervention.AreaHouse') }}
            </div>
            <div>
              {{ addressIntervention.areaHouse }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 mb-2 mt-2" style="font-size: 110%">
            <span v-if="addressIntervention.bathroomQuantity != null" class="mr-1">
              <span class="bold-text">{{ addressIntervention.bathroomQuantity }}</span> {{ $t('addressIntervention.bathroomQuantity') }}
            </span>
            <span v-if="addressIntervention.bathtubQuantity != null" class="mr-1">
              <span class="bold-text">{{ addressIntervention.bathtubQuantity }}</span> {{ $t('addressIntervention.bathtubQuantity') }}
            </span>
            <span v-if="addressIntervention.showerQuantity != null" class="mr-1">
              <span class="bold-text">{{ addressIntervention.showerQuantity }}</span> {{ $t('addressIntervention.showerQuantity') }}
            </span>
            <span v-if="addressIntervention.basinQuantity != null" class="mr-1">
              <span class="bold-text">{{ addressIntervention.basinQuantity }}</span> {{ $t('addressIntervention.basinQuantity') }}
            </span>
            <span v-if="addressIntervention.bidetQuantity != null" class="mr-1">
              <span class="bold-text">{{ addressIntervention.bidetQuantity }}</span> {{ $t('addressIntervention.bidetQuantity') }}
            </span>
            <span v-if="addressIntervention.sinkQuantity != null" class="mr-1">
              <span class="bold-text">{{ addressIntervention.sinkQuantity }}</span> {{ $t('addressIntervention.sinkQuantity') }}
            </span>
          </div>
        </div>

        <div class="row" v-if="addressIntervention.note != null">
          <div class="col-12">
            <div class="card-subtitle mt-2 mb-1">
              {{ $t('addressIntervention.Informations') }}
            </div>
            <div class="installation-information">
              {{ addressIntervention.note }}
            </div>
          </div>
        </div>
        <div v-if="photoAddressInterventions && photoAddressInterventions.length>0">
          <div class="col">
            <div class="bold-text main-color mb-1 mt-4" style="font-size: 150%;">
              {{ $t("Photos") }}
            </div>
            <div class="row ">
              <div v-for="photoAddressIntervention in photoAddressInterventions" class="col-12 col-md-6 col-lg-4">
                <a :href=fullFileUrl(photoAddressIntervention.fileUrl) class="" target="_blank">
                  <button class="btn-icon download-photo-icon">
                    <download-icon/>
                  </button>
                </a>
                <img
                  style="width: 100%"
                  :src="fullFileUrl(photoAddressIntervention.fileUrl)"
                  @click="zoomOnImage(fullFileUrl(photoAddressIntervention.fileUrl))"
                  alt="Photo associée à l'appareil"
                >
              </div>
            </div>
          </div>
        </div>
      </b-card>
    </b-container>
    <InterventionDeleteModal :selectedIntervention="ui.selectedIntervention" @didDeleteIntervention="didDeleteIntervention()"></InterventionDeleteModal>
    <AddressInterventionDeleteModal :selected-address-intervention="addressIntervention" @didDeleteAddressIntervention="didDeleteAddressIntervention"></AddressInterventionDeleteModal>
    <!-- Modal Zoom on image -->
    <zoom-on-image v-if="ui.zoomOnImageSrc !== null" :src="ui.zoomOnImageSrc" @didCloseZoomOnImage="didCloseZoomOnImage"></zoom-on-image>

  </div>
</template>

<script>
import api from '../../services/api';
import BackArrow from "../../components/b122/BackArrow";
import ShowActions from "../../components/b122/ShowActions";
import B122Table from "../../components/b122/B122Table";
import {dateUtils} from "@/mixins/utils";
import ZoomOnImage from "../../components/b122/ZoomOnImage";
import InterventionDeleteModal from "../intervention/InterventionDeleteModal";
import AddressInterventionDeleteModal from "./AddressInterventionDeleteModal";

export default {

  name: 'AddressInterventionShow',

  components: {
    BackArrow,
    ShowActions,
    B122Table,
    ZoomOnImage,
    InterventionDeleteModal,
    AddressInterventionDeleteModal
  },

  data() {
    return {
      devices: [],
      addressInterventionId: this.$route.params.addressInterventionId,
      addressIntervention: {},
      ui: {
        zoomOnImageSrc: null,
        selectedIntervention: null
      },
      photoAddressInterventions: {},
      tableFields: [
        {
          label: "",
          key: "show",
          sortable: false
        },
        {
          label: this.$i18n.t('Technician'),
          key: "technician.name",
          sortable: true,
          sortKey: "technician.firstName"
        },
        {
          label: this.$i18n.t('intervention.Date'),
          key: "estimatedStartDate",
          sortable: true,
          formatter: function (value) {
            return dateUtils.methods.formatDateSimple(value);
          }
        },
        {
          label: this.$i18n.t('intervention.Description'),
          key: "description",
          sortable: false
        },
        {
          label: "",
          key: "actions"
        }
      ],
    }
  },

  computed: {
    addressTitle() {
      return this.addressIntervention.name
    }
  },

  mounted() {
    this.fetchData()
  },

  methods: {
    //region fetch
    async fetchData() {
      await this.fetchAddressIntervention()
      this.fetchAllDevice()
      this.fetchFileAddressIntervention()
    },

    fetchAddressIntervention() {
      return api
        .get(`/addressIntervention/${this.addressInterventionId}`)
        .then(response => {
          this.addressIntervention = response.data
        })
    },

    fetchAllDevice() {
      api
        .get(`/addressIntervention/getAllDeviceByAddressIntervention?addressInterventionId=${this.addressIntervention.id}`)
        .then(response => {
          this.devices = response.data
        })
    },

    fetchFileAddressIntervention() {
      return api
        .get(`/fileAddressIntervention/getFileAddressInterventionsByAddressInterventionId?addressInterventionId=${this.addressIntervention.id}`)
        .then(response => {
          this.photoAddressInterventions = response.data
        })
    },
    //endregion
    //region historic
    clickOnShowInterventionBtn(row) {
      this.$router.push({
        name: 'InterventionShow',
        params: {
          interventionId: row.item.id
        }
      })
    },

    clickOnEditInterventionBtn(row) {
      this.$router.push({
        name: 'InterventionEdit',
        params: {
          interventionId: row.item.id
        }
      })
    },

    clickOnDeleteInterventionBtn(row) {
      this.ui.selectedIntervention = row.item
      this.$bvModal.show('intervention-delete-modal')
    },

    didDeleteIntervention(){
      this.$refs.B122TableIntervention.refreshTable()
    },
    //endregion
    //region actions
    clickOnEditBtn(){
      this.$router.push({
        name: 'AddressInterventionEdit',
        params: {
          addressInterventionId: this.addressIntervention.id
        }
      })
    },

    clickOnDeleteBtn() {
      this.$bvModal.show('addressIntervention-delete-modal')
    },

    didDeleteAddressIntervention() {
      this.$router.push({
        name: 'AddressInterventionIndex'
      }, () => {
        this.$nextTick(() => {
          this.successToast(this.$i18n.t('AddressIntervention') + ' "' + this.addressIntervention.name + " " + this.$i18n.t('f.deleted'))
        })
      })
    },

    successToast(message) {
      this.$bvToast.toast(message, {
        autoHideDelay: 2000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true
      })
    },

    goToDevice(device) {
      this.$router.push({
        name: 'DeviceShow',
        params: {
          deviceId: device.id,
          addressName: this.addressIntervention.name
        }
      })
    },

    goToClient(type) {
      let id = null;
      if(type === "agency") id = this.addressIntervention.agency.id
      if(type === "tenant") id = this.addressIntervention.tenant.id
      if(type === "owner") id = this.addressIntervention.owner.id

      if(id != null){
        this.$router.push({
          name: 'ClientShow',
          params: {
            clientId: id
          }
        })
      }
    },

    goToNewIntervention(){
      this.$router.push({
        name: 'InterventionCreate',
        params: {
          selectedAddressIntervention: this.addressIntervention
        }
      })
    },
    //endregion
    //region documents

    fullFileUrl(fileUrl) {
      return process.env.SERVER_URL + fileUrl
    },

    zoomOnImage(imageSrc) {
      this.ui.zoomOnImageSrc = imageSrc
    },

    didCloseZoomOnImage() {
      this.ui.zoomOnImageSrc = null
    },

    setTotalCount(totalCount) {
      this.totalCount = totalCount
    },
  //  endregion
  }
}
</script>

<style scoped>
.installation-information{
  padding: 8px 16px;
  background-color: var(--light-grey);
  border: var(--light-grey-border) 1px solid;
  border-radius: 4px;
}
</style>



// WEBPACK FOOTER //
// src/views/addressIntervention/AddressInterventionShow.vue